/**
 * @Description 不合适标记原因展示组件
 */
import { FC, useContext } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { CollectListContext } from '@/views/youth/pages/map/ts-config';
import { UnsuitableMarkType } from '@/common/components/business/YouthMap/Common/AreaMarking';
import styles from './index.module.less';

interface AreaMarkingReasonProps {
  detail: {
    id: number;
    unsuitableMark?: UnsuitableMarkType | null;
    [p: string]: any;
  };
}

const AreaMarkingReason: FC<AreaMarkingReasonProps> = ({ detail }) => {
  const { unsuitableMarkMap }: any = useContext(CollectListContext) || {};

  // 优先取Context中的记录，否则取detail自身数据
  const markData: UnsuitableMarkType | null = unsuitableMarkMap && (detail.id in unsuitableMarkMap)
    ? unsuitableMarkMap[detail.id]
    : detail.unsuitableMark || null;

  if (!markData) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.operator}>
          <UserOutlined className={styles.userIcon} />
          {markData.operatorName}
        </div>
        <div className={styles.date}>{markData.createdAt}</div>
      </div>
      <div className={styles.reason}>不合适原因：{markData.reason}</div>
    </div>
  );
};

export default AreaMarkingReason;
